// 20.1.2.3 Number.isInteger(number)
var isObject = require('./_is-object');
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};



//////////////////
// WEBPACK FOOTER
// ../~/_core-js@2.6.9@core-js/library/modules/_is-integer.js
// module id = 1020
// module chunks = 0